export const ORGANIZATION_SIGNUPS_TABLE_FIELDS = [
  {
    name: 'Nonprofit Name',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'nonprofitName',
    displayField: 'nonprofitName',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Profile Page',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'profilePageName',
    displayField: 'profilePageName',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Admin Name',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'adminName',
    displayField: 'adminName',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Admin Email',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'adminEmail',
    displayField: 'adminEmail',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Classification',
    class: 'table-cell align-middle w-1/6 cursor-pointer pl-2',
    sortKey: 'nonprofitClassification',
    displayField: 'nonprofitClassification',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Submitted',
    class: 'table-cell align-middle w-1/12 cursor-pointer pl-2',
    sortKey: 'createdAt',
    displayField: 'createdAt',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Status',
    class: 'table-cell align-middle w-1/12 cursor-pointer',
    sortKey: 'status',
    displayField: 'status',
    sortOrder: ['desc', 'asc'],
  },
  {
    name: 'Actions',
    displayField: 'Actions',
    class: 'table-cell align-middle w-1/12 text-right pr-8',
  },
]
